import {
  ByIdPayload,
  FailByIdPayload,
  OperationReducerTypes,
  PayloadAction,
  uniqueActionType
} from '@industi/ngx-common';

export const ItemImageDeleteActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[item/image] Delete'),
  requestFail: uniqueActionType('[item/image] Delete fail'),
  requestSuccess: uniqueActionType('[item/image] Delete success'),
  requestClearErrors: uniqueActionType('[item/image] Delete clear errors'),
  requestClear: uniqueActionType('[item/image] Delete clear')
};

export class ItemImageDeleteAction implements PayloadAction {
  readonly type = ItemImageDeleteActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class ItemImageDeleteFailAction implements PayloadAction {
  readonly type = ItemImageDeleteActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ItemImageDeleteSuccessAction implements PayloadAction {
  readonly type = ItemImageDeleteActionTypes.requestSuccess;

  constructor(public payload: ByIdPayload) {
  }
}

export class ItemImageDeleteClearErrorsAction implements PayloadAction {
  readonly type = ItemImageDeleteActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class ItemImageDeleteClearAction implements PayloadAction {
  readonly type = ItemImageDeleteActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
